import React from 'react';
import { Card, Row, Col, Statistic } from 'antd';
import { useSelector } from 'react-redux';
import { formatPrice } from '../../../lib/utils';

export default function TotalsSummary({ liquidaciones }) {
  const signoMoneda = useSelector((state) => state.signoMoneda.signo_moneda);
  const totals = liquidaciones.reduce((acc, liquidacion) => {
    acc.total_facturas += parseFloat(liquidacion.total_facturas || 0);
    acc.total_credito += parseFloat(liquidacion.total_credito || 0);
    acc.total_devoluciones += parseFloat(liquidacion.total_devoluciones || 0);
    acc.total_diferencias += parseFloat(liquidacion.diferencia || 0);
    return acc;
  }, {
    total_facturas: 0,
    total_credito: 0,
    total_devoluciones: 0,
    total_diferencias: 0
  });

  return (
    <Card style={{ marginBottom: 16 }}>
      <Row gutter={16}>
        <Col span={6}>
          <Statistic
            title="Total Facturas"
            value={formatPrice(totals.total_facturas,signoMoneda)}
            precision={2}
            prefix="$"
          />
        </Col>
        <Col span={6}>
          <Statistic
            title="Total Crédito"
            value={formatPrice(totals.total_credito,signoMoneda)}
            precision={2}
            prefix="$"
          />
        </Col>
        <Col span={6}>
          <Statistic
            title="Total Devoluciones"
            value={formatPrice(totals.total_devoluciones,signoMoneda)}
            precision={2}
            prefix="$"
          />
        </Col>
        <Col span={6}>
          <Statistic
            title="Total Diferencias"
            value={formatPrice(totals.total_diferencias,signoMoneda)}
            precision={2}
            prefix="$"
            valueStyle={{ color: totals.total_diferencias < 0 ? '#cf1322' : '#3f8600' }}
          />
        </Col>
      </Row>
    </Card>
  );
}